import CampusSkillEnhanceDynamic from '../../CampusSharedComponent/CampusDynamicPages/CampusSkillEnhanceDynamicPage/CampusSkillEnhanceDynamic';
import nanmudhalvan1 from "../../../assets/CampuLifeImages/nanmudhalvan1.jpeg"
import nanmudhalvan2 from "../../../assets/CampuLifeImages/nanmudhalvan2.jpeg"
import nanmudhalvan3 from "../../../assets/CampuLifeImages/nanmudhalvan3.jpeg"
import nanmudhalvan4 from "../../../assets/CampuLifeImages/nanmudhalvan4.jpeg"



const Enterpreneurship = () => {
   const hoverContent = [
    {  img: nanmudhalvan3, para1: "Naan Mudhalvan scheme implementation @nicas", para2: "Feb 25 2023" },
    {  img:nanmudhalvan4, para1: "Naan Mudhalvan scheme implementation @nicas", para2: "Feb 25 2023"  },
    { img: nanmudhalvan1, para1: "Nan Mudhalvan Training at MS University campus", para2: "December 18 - December 24" },
    { img: nanmudhalvan2, para1: "Nan Mudhalvan Training at MS University campus", para2: "December 18 - December 24" },
  ]

  const data = {
        name: "TNSDC/Naan Mudhalvan",
    title: "TNSDC/Naan Mudhalvan Committee Activities",
    para: "Government of Tamil Nadu aimed at empowering youth through skill development, career guidance, and industry-relevant training. Designed to enhance the employability of students across the state, the scheme offers a wide range of learning opportunities including technical courses, soft skills training, and exposure to emerging fields such as AI, data science, and cybersecurity. Through strategic partnerships with educational institutions, industries, and global platforms, Naan Mudhalvan bridges the gap between academic learning and real-world industry needs. Noorul Islam College of Arts & Science, actively participates in this initiative by integrating Naan Mudhalvan programs into its curriculum and offering students access to valuable resources, workshops, and certification courses that prepare them for future careers.",
    fourhover: true
  }

  return (
    <>
      <CampusSkillEnhanceDynamic data={data} content={hoverContent} />
    </>
  )
}

export default Enterpreneurship